import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create an axios instance that auto-attaches JWT token
const adminApi = axios.create({
  baseURL: API_BASE
});

// Request interceptor - attach token to every request
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('ashop_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handle 401 (expired/invalid token)
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid - force re-login
      localStorage.removeItem('ashop_admin');
      localStorage.removeItem('ashop_admin_token');
      window.location.href = '/admin-login';
    }
    return Promise.reject(error);
  }
);

export default adminApi;
